module.exports = "/img/_/_/_/assets/images//navigation_drawer_hide.png?1077c1bd274a728e8a2222d27b015491";